import { handleDownloadOnClick } from "@_common/downloadfile";
import { formatSmallString } from "@_common/format-text";
import { getValue } from "@utils/lodash";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";
import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const DocumentStorePopup = (props: any) => {
  return (
    <div>
      <Modal
        isOpen={props.documentStoreIsOpen}
        toggle={props.handleDocumentStore}
      >
        <ModalHeader toggle={props.handleDocumentStore}>
          Reference Document
        </ModalHeader>
        <ModalBody className="m-0">
          
          {getValue(props, `docStoreData`, []).length === 0 ? (
            <p>No reference document</p>
          ) : (
            getValue(props, `docStoreData`, []).map((item:any) => (
              <div key={item.id}>
                {getValue(item, "documents", []).map((document:any) => (
                  <div
                    className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between mt-2"
                    key={document.id}
                    onClick={() =>
                      handleDownloadOnClick(document.url, document.name)
                    }
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        marginTop: "0px",
                        textAlign: "center",
                      }}
                    >
                      {formatSmallString(document.name)}
                    </p>

                    <DownloadNoCircleSvgComponent size={18} />
                  </div>
                ))}
              </div>
            ))
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="p-2"
            color="primary"
            onClick={props.handleDocumentStore}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DocumentStorePopup;
